<c-card *transloco="let t">
  <c-card-body>
    <div>

      <h3><i class="fa fa-star gold" aria-hidden="true"></i> {{ t('Welcome to the Lone Worker Safety Awards') }}</h3>

      <p>{{ t('Keeping your workers') }} <b>{{ t('safe') }}</b> {{ t('is important to us.') }} <b>{{ t('Staying safe') }}</b> {{ t('is very important to') }} <b>{{ t('your workers and your company') }}</b>! {{ t("But just because something is important, doesn’t mean it can’t be") }} <b>{{ t('fun') }}</b> {{ t('too') }}!</p>

      <p>{{ t("OK Alone's") }} <i class="fa fa-trophy gold" aria-hidden="true"></i> {{ t('Safety Awards offer an engaging way to') }} <b>{{ t('stay safe') }}</b>, {{ t('while using the lone worker system to') }} <b>{{ t('compete') }}</b> {{ t('with colleagues and companies across the world. The program recognises OK Alone feature usage or when a worker completes a safe shift and rewards them with badges, points and rankings.') }}</p>

      <p>{{ t('Who will be the') }} <b>#1 {{ t('WORKER') }}</b> {{ t('in your company, your country or the world?!') }}</p>


    </div>
    <div class="d-flex p-2 bd-highlight justify-content-between">

      <button
      cButton
      id="auto-trigger"
      class="btn-secondary"
      routerLink="awards-main"
      >
        {{ t('Home') }}
      </button>

      <button
      cButton
      class="btn-secondary"
      routerLink="certificates"
      (click)="page='certificates'"
      >
        {{ t('Certificates') }}
      </button>

      <button
      cButton
      class="btn-secondary"
      routerLink="reportcards"
      >
        {{ t('Report Cards') }}
      </button>

      <button
      cButton
      class="btn-secondary"
      routerLink="workerrankings"
      >
        {{ t('Worker Rankings') }}
      </button>

      <button
      cButton
      class="btn-secondary"
      routerLink="companyrankings"
      >
        {{ t('Company Rankings') }}
      </button>

      <button
      cButton
      class="btn-secondary"
      >
        {{ t('Safety Champions') }}
      </button>

    </div>
  </c-card-body>
</c-card>
